const atInternetId = () => {
  const params = new URLSearchParams(document.location.search);
  return parseInt(params.get('atInternetId'), 10);
};

export default atInternetId;
